import { defineComponent as n, computed as o, openBlock as a, createElementBlock as c, createElementVNode as e, toDisplayString as d, createCommentVNode as f, normalizeStyle as h } from "vue";
const _ = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "b7ec4668-f6a0-43a5-a29a-23c195ff70ee" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#b7ec4668-f6a0-43a5-a29a-23c195ff70ee)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "M0 0h512v144.8l-45.8 113L512 367.4V512H0V367.4l46.3-111.1L0 144.8z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 144.8h512v222.6H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#6da544",
  d: "M322.8 300.5 256 178.1l-66.8 122.4h50.1V334h33.4v-33.4z"
}, null, -1), x = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ n({
  __name: "lb",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const t = i, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (a(), c("title", k, d(t.flagName), 1)) : f("", !0),
        p,
        v,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: h({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, _));
  }
});
export {
  B as default
};
//# sourceMappingURL=lb-f6563e39.js.map
